import { z } from 'zod';
/**
 * Schemas + payload parsing for the agent-emitted interactive markdown tags.
 * Ported from airia-platform's catalog/lib/gen/index.ts so the office add-in
 * can render the same custom components the platform renders.
 *
 * Each tag's body carries either:
 *   - `children`: the inline text body delivered by remark, OR
 *   - `artifactContent`: an attribute set by @airia/ui ChatMarkdown's
 *     customTagsPlugin to avoid React's special handling of `children`.
 *
 * For options-based tags (Dropdown/Checkboxes/Radios) the body is a JSON
 * array of `{ label, message }` — parsed at render time via
 * `parseDropdownOptions`. The schemas tolerate missing fields by defaulting
 * to safe values so a malformed agent payload never crashes the chat.
 */
export const MessageButtonSchema = z.object({
    children: z.string().catch(''),
    artifactContent: z.string().catch(''),
    buttonText: z.string().catch(''),
});
export const MessageDropdownSchema = z.object({
    children: z.string().catch(''),
    artifactContent: z.string().catch(''),
    buttonText: z.string().catch(''),
    isLoading: z.boolean().catch(false),
});
export const MessageCheckboxesSchema = z.object({
    children: z.string().catch(''),
    artifactContent: z.string().catch(''),
    buttonText: z.string().catch(''),
    sendButtonText: z.string().catch(''),
    isLoading: z.boolean().catch(false),
});
export const MessageRadiosSchema = z.object({
    children: z.string().catch(''),
    artifactContent: z.string().catch(''),
    buttonText: z.string().catch(''),
    sendButtonText: z.string().catch(''),
    isLoading: z.boolean().catch(false),
});
export const DropdownOptionSchema = z.object({
    label: z.string(),
    message: z.string(),
});
export function parseDropdownOptions(raw) {
    const trimmed = raw.trim();
    if (!trimmed)
        return [];
    try {
        const parsed = JSON.parse(trimmed);
        const result = DropdownOptionSchema.array().safeParse(parsed);
        return result.success ? result.data : [];
    }
    catch {
        return [];
    }
}
